<template>
<div class="chapter">
<div class="inner_page">
<h1>Table of Contents</h1>
<p><span href="#/c001" title="Link target outside of Sample">Title Page</span></p>
<p><span href="#/c002" title="Link target outside of Sample">Copyright Page</span></p>
<p><a href="#/c003">Magic Over Boys (Shadowlight Academy, #2)</a></p>
<p><a href="#/c004"></a></p>
<p><a href="#/c005"></a></p>
<p><a href="#/c006"></a></p>
<p><span href="#/c007" title="Link target outside of Sample"></span></p>
<p><span href="#/c008" title="Link target outside of Sample"></span></p>
<p><span href="#/c009" title="Link target outside of Sample"></span></p>
<p><span href="#/c010" title="Link target outside of Sample"></span></p>
<p><span href="#/c011" title="Link target outside of Sample"></span></p>
<p><span href="#/c012" title="Link target outside of Sample"></span></p>
<p><span href="#/c013" title="Link target outside of Sample"></span></p>
<p><span href="#/c014" title="Link target outside of Sample"></span></p>
<p><span href="#/c015" title="Link target outside of Sample"></span></p>
<p><span href="#/c016" title="Link target outside of Sample"></span></p>
<p><span href="#/c017" title="Link target outside of Sample"></span></p>
<p><span href="#/c018" title="Link target outside of Sample"></span></p>
<p><span href="#/c019" title="Link target outside of Sample"></span></p>
<p><span href="#/c020" title="Link target outside of Sample"></span></p>
<p><span href="#/c021" title="Link target outside of Sample"></span></p>
<p><span href="#/c022" title="Link target outside of Sample"></span></p>
<p><span href="#/c023" title="Link target outside of Sample"></span></p>
<p><span href="#/c024" title="Link target outside of Sample"></span></p>
<p><span href="#/c025" title="Link target outside of Sample"></span></p>
<p><span href="#/c026" title="Link target outside of Sample">SOCIETY OF SUPERNATURAL SLEUTHS</span></p>
<p><span href="#/c027" title="Link target outside of Sample">Scarlet’s Three</span></p>
<p><span href="#/c028" title="Link target outside of Sample">Shadowlight Academy | PLAYLIST</span></p>
<p><span href="#/c029" title="Link target outside of Sample">FADE</span></p>
<p><span href="#/c030" title="Link target outside of Sample">Wicked Woods</span></p>
<p><span href="#/c031" title="Link target outside of Sample">The Stoker Sisters</span></p>
<p><span href="#/c032" title="Link target outside of Sample">BITTER FROST</span></p>
<p><span href="#/c033" title="Link target outside of Sample">Want to Know More about Shadowlight Academy, Author Insight, Author Appearance, Contests and Giveaways? | Get New Releases and News from Kailin Gow at her website kailingow</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?f74f6708